import React from "react";
import { Container, Typography } from "@mui/material";

const TermsPage = () => {
  return (
    <Container>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Terms and Conditions
      </Typography>

      <Typography variant="h4" component="h2" gutterBottom>
        1. Acceptance of Terms
      </Typography>
      <Typography>
        By using our P2P cryptocurrency exchange platform, you agree to comply
        with and be bound by these Terms and Conditions. If you do not agree to
        these terms, please do not use our services.
      </Typography>

      <Typography variant="h4" component="h2" gutterBottom>
        2. Account Registration
      </Typography>
      <Typography>
        To use our platform, you must create an account. You are responsible for
        maintaining the security of your account and password.
      </Typography>

      <Typography variant="h4" component="h2" gutterBottom>
        3. User Responsibilities
      </Typography>
      <Typography>
        - You agree to use our platform for lawful purposes and not engage in
        illegal activities.
        <br />
        - You are responsible for ensuring the accuracy of the information you
        provide.
        <br />- You must not engage in fraudulent or deceptive activities.
      </Typography>

      {/* Add more sections for various terms and conditions as needed */}

      <Typography variant="h4" component="h2" gutterBottom>
        4. Governing Law
      </Typography>
      <Typography>
        These Terms and Conditions are governed by and construed in accordance
        with the laws of [Your Jurisdiction].
      </Typography>

      <Typography variant="h4" component="h2" gutterBottom>
        5. Contact Us
      </Typography>
      <Typography>
        If you have questions or concerns about these Terms and Conditions,
        please contact us at support@example.com.
      </Typography>

      <Typography variant="h4" component="h2" gutterBottom>
        6. Changes to Terms
      </Typography>
      <Typography>
        We reserve the right to update and modify these Terms and Conditions.
        Please check this page regularly for any changes.
      </Typography>
    </Container>
  );
};

export default TermsPage;
